import { render, staticRenderFns } from "./updateInfo.vue?vue&type=template&id=126619ce&scoped=true"
import script from "./updateInfo.vue?vue&type=script&lang=js"
export * from "./updateInfo.vue?vue&type=script&lang=js"
import style0 from "./updateInfo.vue?vue&type=style&index=0&id=126619ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126619ce",
  null
  
)

export default component.exports